import { MUTATE_EINSTELLUNGEN } from '@/domain/dienstplan/features/SettingsMindestbelegung/hooks/graphql/mutations';
import {
  Dienstplan_UpdateSettingsMutation,
  Dienstplan_UpdateSettingsMutationVariables,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';

export function useSettings() {
  const [execute, result] = useMutation<
    Dienstplan_UpdateSettingsMutation,
    Dienstplan_UpdateSettingsMutationVariables
  >(MUTATE_EINSTELLUNGEN, {
    refetchQueries: ['dienstplan_arbeitsbereichByStandortId'],
    awaitRefetchQueries: true,
  });

  const updateEinstellungen = useCallback(
    (variables: Dienstplan_UpdateSettingsMutationVariables) => {
      return execute({ variables });
    },
    [execute],
  );

  return [updateEinstellungen, result] as const;
}
